import navRoutes from 'config/MenuNavConstants';
import { validatePermission } from 'actions';

const flatRoutesPermissions = () => {
  const result = [];
  navRoutes.forEach(({ path, permissionRequired, children }) => {
    if (children) {
      children.forEach((item) =>
        result.push({
          path: item.path,
          permissionRequired: item.permissionRequired,
        }),
      );
    } else {
      result.push({
        path,
        permissionRequired,
      });
    }
  });
  return result;
};

export const verifyMostAcessedPermissions = (mostAcessedRoutes) => {
  const routesPermissions = flatRoutesPermissions();
  const result = [];

  mostAcessedRoutes.forEach((route) => {
    const validRoute = routesPermissions.some((item) => {
      return item.path === route.path && validatePermission(item.permissionRequired);
    });
    if (validRoute) {
      result.push(route);
    }
  });

  return result;
};
